import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {Skeleton} from '../Skeleton';
import {FooterStaticView, FooterStaticViewProps} from './FooterStaticView';
import {useFooterStaticData} from './useFooterStaticData';

export const FooterStatic: React.FC<FooterStaticViewProps> = props => {
  return (
    <DataFetcher
      request={useFooterStaticData()}
      Error={() => null}
      Loading={Loading}
      View={FooterStaticView}
      viewProps={props}
    />
  );
};

const Loading = () => <Skeleton />;
